<template>
  <div id="app">
    <v-btn color="success" @click="salvarProntuario()">Salvar Prontuário</v-btn>
    <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
  </div>
</template>

<script>
import * as FormularioProntuario from "./../services/formulario-prontuario";
import * as AtendimentoProntuario from "./../services/atendimento-prontuario";
import * as AtendimentoRelatorio from "./../services/atendimento-relatorio";

export default {
  name: "Prontuario",
  data() {
    return {
      editorData: "",
      editorConfig: {
        language: "pt-br",
        height: 500,
        // The configuration of the editor.
      },
    };
  },
  created(){
    this.$socket.close()
  },
  mounted() {
    this.getAll();
  },
  methods: {
    async getAll() {
      let tipo = this.$route.params.tipo;
      let prontuario_codigo = this.$route.params.prontuario_codigo;
      if (tipo === "M") {
        let resp = await FormularioProntuario.getByUuid(this.$axios, {
          codigo_uuid: prontuario_codigo,
        });
        if (resp.status === 200) {
          this.editorData = resp.data.prontuario;
        }
      } else if (tipo === "P") {
        let resp = await AtendimentoProntuario.getByUuid(this.$axios, {
          codigo_uuid: prontuario_codigo,
        });
        if (resp.status === 200) {
          this.editorData = resp.data.prontuario;
        }
      } else if (tipo === "R") {
        let resp = await AtendimentoRelatorio.getByUuid(this.$axios, {
          codigo_uuid: prontuario_codigo,
        });
        if (resp.status === 200) {
          this.editorData = resp.data.relatorio;
        }
      }
    },
    async salvarProntuario() {
      let tipo = this.$route.params.tipo;
      let prontuario_codigo = this.$route.params.prontuario_codigo;
      if (tipo === "M") {
        let resp = await FormularioProntuario.updateByUuid(this.$axios, {
          codigo_uuid: prontuario_codigo,
          prontuario: this.editorData,
        });
        if (resp.status === 200) {
          alert("Registro salvo com sucesso!");
        }
      } else if (tipo === "P") {
        let resp = await AtendimentoProntuario.updateByUuid(this.$axios, {
          codigo_uuid: prontuario_codigo,
          prontuario: this.editorData,
        });
        if (resp.status === 200) {
          alert("Registro salvo com sucesso!");
        }
      } else if (tipo === "R") {
        let resp = await AtendimentoRelatorio.updateByUuid(this.$axios, {
          codigo_uuid: prontuario_codigo,
          relatorio: this.editorData,
        });
        if (resp.status === 200) {
         alert("Registro salvo com sucesso!");
        }
      }
    },
  },
};
</script>